module.exports = __webpack_public_path__ + "img/amountCancelled.315c851b.svg";